import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import useAuth from "src/hooks/selectors/useAuth";
import { updateProfile } from "src/redux/auth";

export default function useUnreads() {
	const dispatch = useDispatch();
	const auth = useAuth();
	const [loading, setLoading] = useState(false);
	const setUnreads = (unreads: any) => {
		dispatch(
			updateProfile({
				...(auth?.unreads || {}),
				unreads,
			})
		);
	};
	const fetchUnreads = () => {
		setLoading(true);
		return axios
			.get("/auth/profile/unreads")
			.then(async ({ data }) => {
				setUnreads(data?.data);
			})
			.finally(() => setLoading(false))
			.catch(console.log);
	};

	return {
		unreads: auth?.unreads,
		fetchUnreads,
		setUnreads,
		loading,
	};
}

export function useFetchUnreadsOnMount() {
	const { fetchUnreads, loading } = useUnreads();

	useEffect(() => {
		fetchUnreads();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return {
		loading,
	};
}
